import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustom0283Contacts({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="currentColor" fillRule="nonzero">
        <path d="M16 .5H4A1.5 1.5 0 002.5 2v16A1.5 1.5 0 004 19.5h12a1.5 1.5 0 001.5-1.5V2A1.5 1.5 0 0016 .5zm-12 1h12a.5.5 0 01.5.5v16a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5z" />
        <path d="M4 3.25a.75.75 0 01.102 1.493L4 4.75H2a.75.75 0 01-.102-1.493L2 3.25h2zM4 6.25a.75.75 0 01.102 1.493L4 7.75H2a.75.75 0 01-.102-1.493L2 6.25h2zM4 9.25a.75.75 0 01.102 1.493L4 10.75H2a.75.75 0 01-.102-1.493L2 9.25h2zM4 12.25a.75.75 0 01.102 1.493L4 13.75H2a.75.75 0 01-.102-1.493L2 12.25h2zM4 15.25a.75.75 0 01.102 1.493L4 16.75H2a.75.75 0 01-.102-1.493L2 15.25h2zM15 5a.25.25 0 01.057.493L15 5.5H9a.25.25 0 01-.057-.493L9 5h6zM7.25 4.5a.75.75 0 110 1.5.75.75 0 010-1.5zm0 .5a.25.25 0 100 .5.25.25 0 000-.5zM15 8a.25.25 0 01.057.493L15 8.5H9a.25.25 0 01-.057-.493L9 8h6zM7.25 7.5a.75.75 0 110 1.5.75.75 0 010-1.5zm0 .5a.25.25 0 100 .5.25.25 0 000-.5z" />
        <g>
          <path d="M15 11a.25.25 0 01.057.493L15 11.5H9a.25.25 0 01-.057-.493L9 11h6zM7.25 10.5a.75.75 0 110 1.5.75.75 0 010-1.5zm0 .5a.25.25 0 100 .5.25.25 0 000-.5z" />
        </g>
        <g>
          <path d="M15 14a.25.25 0 01.057.493L15 14.5H9a.25.25 0 01-.057-.493L9 14h6zM7.25 13.5a.75.75 0 110 1.5.75.75 0 010-1.5zm0 .5a.25.25 0 100 .5.25.25 0 000-.5z" />
        </g>
      </g>
    </svg>
  );
}
export default SvgIconCustom0283Contacts;
